module.exports = __webpack_public_path__ + "static/BiancoSansNew-Bold-564cb3d5e2332e74c14a55d282f1ec0e.woff2";